// export const baseUrl = "https://json-server-cookbook1.glitch.me/";

export const baseUrl = "https://cookbookserver.com/";

// export const baseUrl = "http://127.0.0.1:3000/";

export const baseUrlcdn =
  "https://cdn.glitch.me/fa975902-7a10-4922-b93a-5444668498f7%2F";
